import type { ListPersonsParams } from '@amarantos/api-client'
import { z } from 'zod/v3'

export const userRoles = ['owner', 'supervisor', 'foreman', 'employee', 'inspector', 'contact'] as const

export const roleFilterValues = ['all', ...userRoles] as const

const baseUsersSearchSchema = z.object({
	page: z.coerce.number().int().positive().default(1),
	perPage: z.coerce.number().int().positive().max(100).default(10),
	role: z.enum(roleFilterValues).default('all'),
})

const drawerSearchStateSchema = z.union([
	z.object({
		mode: z.literal('create'),
		personId: z.undefined().optional(),
	}),
	z.object({
		mode: z.literal('edit'),
		personId: z.coerce.number().int().positive(),
	}),
	z.object({
		mode: z.literal('access'),
		personId: z.coerce.number().int().positive(),
	}),
	z.object({
		mode: z.undefined().optional(),
		personId: z.undefined().optional(),
	}),
])

export const usersSearchSchema = baseUsersSearchSchema.and(drawerSearchStateSchema)

export type UsersSearch = z.infer<typeof usersSearchSchema>

export function toListPersonsParams(search: UsersSearch): ListPersonsParams {
	return {
		page: search.page,
		per_page: search.perPage,
		role: search.role === 'all' ? undefined : search.role,
	}
}
